export default __webpack_public_path__ + "static/media/crossroads6.bf1bdca0.webp";